import axios from "axios";
// import { reject, resolve } from "core-js/fn/promise";
import qs from "qs";
import store from "@/store";
import router from "@/router";
import { useRouter } from 'vue-router'
import { Message } from "view-ui-plus";
// import router from "@/router";

// const route = useRouter();
//qs.stringify()是将对象 序列化成URL的形式，以&进行拼接
//  let protocol = window.location.protocol; //协议
//  let host = window.location.host; //主机
//  axios.defaults.baseURL = protocol + "//" + host;

axios.defaults.baseURL = "https://www.yb-erp.com:8081"; //https://192.168.50.2:8081
// axios.defaults.baseURL = "https://192.168.50.2:8081"
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers["Authorization"] = sessionStorage.getItem("token");
axios.defaults.headers['token'] = 'fegin_token';


axios.defaults.timeout = 5000;
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    config.headers.Authorization = sessionStorage.getItem("token");
    // config.headers.token = sessionStorage.getItem("token");
    // 得到参数中的 requestName 字段，用于决定下次发起请求，取消对应的 相同字段的请求
    // 如果没有 requestName 就默认添加一个 不同的时间戳
    let requestName;
    if (config.method === "post") {
      if (config.data && config.data.requestName) {
        requestName = config.data.requestName;
      } else {
        requestName = new Date().getTime();
      }
    } else {
      if (config.params && config.params.requestName) {
        requestName = config.params.requestName;
      } else {
        requestName = new Date().getTime();
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//响应拦截
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response); //进行中
    } else {
      return Promise.reject(response);
    }
  },
  //状态码不是200的情况
  (error) => {
    console.log(error);
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
				error.message = '错误请求'
				Message.warning("错误请求")
				break
			case 401:
				error.message = '未授权，请重新登录';
				Message.warning("您好，您的身份信息已失效，请重新登录。")
				setTimeout(function() {
					router.push('/') // token失效跳转
				}, 3000)
				break
			case 403:
				error.message = '拒绝访问'
				Message.warning("拒绝访问")
				break
			case 404:
				error.message = '请求错误,未找到该资源'
				Message.warning("请求错误,未找到该资源")
				break
			case 405:
				error.message = '请求方法未允许'
				Message.warning("请求方法未允许")
				break
			case 408:
				error.message = '请求超时'
				Message.warning("请求超时")
				break
			case 500:
				error.message = '服务器端出错'
				Message.warning("服务器端出错")
				break
			case 501:
				error.message = '网络未实现'
				Message.warning("网络未实现")
				break
			case 502:
				error.message = '网络错误'
				Message.warning("网络错误")
				break
			case 503:
				error.message = '服务不可用'
				Message.warning("服务不可用")
				break
			case 504:
				error.message = '网络超时'
				Message.warning("网络超时")
				break
			case 505:
				error.message = 'http版本不支持该请求'
				Message.warning("http版本不支持该请求")
				break
			default:
				error.message = `连接错误${error.response.status}`
      }
    } else {
      error.message = "连接到服务器失败，将在三秒后重新登陆";
		  Message.warning("连接到服务器失败，将在三秒后跳转到登录页")
    }
    return Promise.reject(error.response);
  }
);

/**
 * get方法 对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求的参数]
 */

const $get = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      params,
    }).then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    // axios
    //   .get(url, qs.stringify(params))
    //   .then((res) => {
    //     resolve(res);
    //   })
    //   .catch((err) => {
    //     reject(err);
    //   });
  });
};

const $GET =  (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      params,
    }).then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    // axios
    //   .get(url, qs.stringify(params))
    //   .then((res) => {
    //     resolve(res);
    //   })
    //   .catch((err) => {
    //     reject(err);
    //   });
  });
};


/**
 * post方法 对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

const $post = (url, params) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(params)) //是将对象 序列化成URL的形式，以&进行拼接
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const $delete = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.delete(url, qs.stringify(params)).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
} 


export default {
  install: (app) => {
    app.config.globalProperties["$get"] = $get;
    app.config.globalProperties["$GET"] = $GET;
    app.config.globalProperties["$post"] = $post;
    app.config.globalProperties["$delete"] = $delete;
    app.config.globalProperties["$axios"] = axios;
    app.config.globalProperties["$serverUrl"] = "https://www.yb-erp.com:8081";
    // app.config.globalProperties["$serverUrl"] = "https://192.168.50.2:8081";
    app.config.globalProperties["$imageUrl"] = "https://www.yb-erp.com/upload/";
  },
};
